
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("8Egc9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e5307aa4b0c59619$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Czech
var $e5307aa4b0c59619$export$2e2bcd8739ae039 = {
    'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyright': "Vyu\u017E\xedv\xe1 Atlassian Intelligence",
    'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyrightShort': "Vyu\u017E\xedv\xe1 AI",
    'fabric.editor.ai.commandPalette.footer.disclaimerText': "Obsah je zalo\u017Een na va\u0161ich opr\xe1vn\u011Bn\xedch a\xa0jeho kvalita se m\u016F\u017Ee r\u016Fznit.",
    'fabric.editor.ai.commandPalette.footer.disclaimerTextShort': "Kvalita obsahu se m\u016F\u017Ee r\u016Fznit.",
    'fabric.editor.ai.commandPalette.footer.disclaimerTextUpdated': "Vyu\u017E\xedv\xe1 AI. V\xfdsledky si ov\u011B\u0159te.",
    'fabric.editor.ai.commandPalette.footer.infoIconLabel': 'Informace',
    'fabric.editor.ai.commandPalette.footer.rovoCopyright': 'Rovo',
    'fabric.editor.ai.commandPalette.footer.usePageKnowledgeToggleLabel': "Zahrnout znalosti z\xa0aktu\xe1ln\xed str\xe1nky",
    'fabric.editor.ai.commandPalette.promptForm.logo': 'Logo Atlassian Intelligence',
    'fabric.editor.ai.components.backIconButton.backLabel': "Zp\u011Bt",
    'fabric.editor.ai.components.cancelEscButton.cancelLabel': "Zru\u0161it",
    'fabric.editor.ai.components.cancelEscButton.escLabel': 'Esc',
    'fabric.editor.ai.components.cancelIconButton.cancelLabel': "Zru\u0161it",
    'fabric.editor.ai.components.cancelIconButton.cancelTooltip': "Zru\u0161it",
    'fabric.editor.ai.components.feedbackForm.badResponse': "\u0160patn\xe1 odpov\u011B\u010F",
    'fabric.editor.ai.components.feedbackForm.feedbackSent': "Zp\u011Btn\xe1 vazba byla odesl\xe1na",
    'fabric.editor.ai.components.feedbackForm.goodResponse': "Dobr\xe1 odpov\u011B\u010F",
    'fabric.editor.ai.config.item.action.continueFromLatestResponse': "Pokra\u010Dovat od posledn\xed odpov\u011Bdi",
    'fabric.editor.ai.config.item.action.copyResponse': "Kop\xedrovat",
    'fabric.editor.ai.config.item.action.responseCopied': "Zkop\xedrov\xe1no",
    'fabric.editor.ai.config.item.action.responseCopiedToClipboard': "Zkop\xedrov\xe1no do schr\xe1nky",
    'fabric.editor.ai.config.item.action.retryPrompt': 'Zkusit znovu',
    'fabric.editor.ai.experience-application.documentInsertError': "P\u0159i vkl\xe1d\xe1n\xed odpov\u011Bdi se vyskytl probl\xe9m. Zav\u0159ete dialog a\xa0zkuste to znovu.",
    'fabric.editor.ai.experience-application.tokenLimitExceeded': "Na\u010Dten\xed odpov\u011Bdi se nezda\u0159ilo. Va\u0161e v\xfdzva nebo odpov\u011B\u010F p\u0159ekro\u010Dila limit pro tuto \u017E\xe1dost. Zav\u0159ete dialog a\xa0zkuste to znovu.",
    'fabric.editor.ai.experience.apiError': "Z\xedsk\xe1n\xed odpov\u011Bdi se nezda\u0159ilo, zkuste to znovu.",
    'fabric.editor.ai.experience.commandPaletteAriaName': 'Atlassian Intelligence',
    'fabric.editor.ai.experience.inputTooShortError': "Obsah je pro souhrn p\u0159\xedli\u0161 kr\xe1tk\xfd. P\u0159idejte dal\u0161\xed a\xa0zkuste to znovu.",
    'fabric.editor.ai.experience.loadingAriaTitle': 'Generuje se',
    'fabric.editor.ai.experience.previewScreenLabel': "N\xe1hled",
    'fabric.editor.ai.experience.rovoAgents.agentPalette.placeholder': "\u0158ekn\u011Bte agentovi, aby n\u011Bco napsal, nebo si vyberte z\xa0mo\u017Enost\xed n\xed\u017Ee.",
    'fabric.editor.ai.experience.rovoAgents.productLabel': 'Rovo',
    'fabric.editor.ai.experience.rovoAgents.productLogoAltText': 'Logo Rovo',
    'fabric.editor.ai.screens.UserInputCommamdPalette.footerText': 'Atlassian Intelligence',
    'fabric.editor.ai.screens.discard.cancelLabel': "Zp\u011Bt",
    'fabric.editor.ai.screens.discard.discardLabel': 'Zahodit',
    'fabric.editor.ai.screens.error.warningIconLabel': "Upozorn\u011Bn\xed",
    'fabric.editor.ai.screens.error.ariaErrorTitle': 'Chyba',
    'fabric.editor.ai.screens.error.cancelLabel': "Zru\u0161it",
    'fabric.editor.ai.screens.error.retryLabel': 'Zkusit znovu',
    'fabric.editor.ai.screens.loading.adfContentAriaLiveRegionDescription': "\u017Div\xe1 aktualizace obsahu:",
    'fabric.editor.ai.screens.loading.iconAltText': "Generov\xe1n\xed ikony",
    'fabric.editor.ai.screens.preview.actionButtonsAccessibleLabel': "Akce pro obsah vygenerovan\xfd AI",
    'fabric.editor.ai.screens.preview.betaLabel': 'Beta',
    'fabric.editor.ai.screens.preview.cancelLabel': "Zru\u0161it",
    'fabric.editor.ai.screens.preview.defaultAIPlaceholder': "\u0158ekn\u011Bte AI, co d\u011Blat d\xe1l.",
    'fabric.editor.ai.screens.preview.discardLabel': 'Zahodit',
    'fabric.editor.ai.screens.preview.disclaimer': "Kvalita informac\xed se m\u016F\u017Ee r\u016Fznit.",
    'fabric.editor.ai.screens.preview.disclaimerLink': "Pro\u010D?",
    'fabric.editor.ai.screens.preview.header.clear.hover': 'Vymazat',
    'fabric.editor.ai.screens.preview.header.edit': "Upravit v\xfdzvu",
    'fabric.editor.ai.screens.preview.header.edit.hover': 'Upravit',
    'fabric.editor.ai.screens.preview.placeholderWithAgent': "Zeptejte se agenta {agentName}, co d\u011Blat d\xe1l.",
    'fabric.editor.ai.screens.preview.refineButton': "Zp\u0159esnit",
    'fabric.editor.ai.screens.preview.refineDropdown.refineButton': "Zp\u0159esnit",
    'fabric.editor.ai.screens.prompt.logoAltText': 'Logo Atlassian Intelligence',
    'fabric.editor.ai.screens.prompt.logoText': 'Atlassian Intelligence',
    'fabric.editor.ai.screens.prompt.submitLabel': 'Odeslat',
    'fabric.editor.ai.screens.prompt.submitTooltip': 'Odeslat do AI',
    'fabric.editor.ai.screens.promptWithSelectedOption.promptSelected': "{promptName} \u2013 vybr\xe1no",
    'fabric.editor.ai.screens.promptWithSelectedOption.removeLabel': 'Odebrat',
    'fabric.editor.ai.shared.aiProactiveButtonLabel': "N\xe1vrhy",
    'fabric.editor.ai.shared.aiUniversalDescriptor': "Asistent p\u0159i psan\xed",
    'fabric.editor.ai.shared.aiUniversalLongCallToAction': "Nechte si p\u0159i psan\xed pomoci od Atlassian Intelligence.",
    'fabric.editor.ai.shared.aiUniversalShortCallToAction': "Ps\xe1t",
    'fabric.editor.ai.shared.betaLabel': 'Beta',
    'fabric.editor.ai.shared.generateContent.aiButtonTitle': 'AI (Atlassian Intelligence)',
    'fabric.editor.ai.ui.components.suggestions.betaLozenge': 'BETA',
    'fabric.editor.ai.ui.components.suggestions.newLozenge': "NOV\xc9",
    'fabric.editor.ai.ui.components.suggestions.tellAILabel': "\u0158ekn\u011Bte AI",
    'fabric.editor.ai.ui.components.suggestions.tellAgentLabel': "Pov\u011Bd\u011Bt agentovi"
};

});


//# sourceMappingURL=cs.aa1abe0d.js.map
